export default __webpack_public_path__ + "static/media/2025.12.11 - 2022.12.11 - FCSI - ISO 9001_2015 Cert.  Conformità nr.  34581_16_S.08ead72b.pdf";